import { LEGAL_PAGES_EN } from "./legal.en";

export const getLegalPages = (lang) => (lang === "en" ? LEGAL_PAGES_EN : LEGAL_PAGES);

export const PENDING_NOTE =
  "Los campos marcados corresponden a configuración pendiente y deben completarse antes de la publicación en producción.";

export const LEGAL_PAGES = {
  "aviso-legal": {
    title: "Aviso legal",
    description: "Aviso legal del sitio onix-cybersecurity.tech, titularidad de ARÁNDANO PARTNERS, S.L.",
    sections: [
      {
        heading: "1. Titular del sitio",
        paragraphs: [
          "El sitio web onix-cybersecurity.tech es titularidad de ARANDANO PARTNERS, S.L., con CIF B75419093 y domicilio social en Calle Camp, 2, planta 1, 08021 Barcelona, España. Inscrita en el Registro Mercantil de Barcelona, sección 8, hoja B-625732, inscripción 1. Correo electrónico de contacto: sistemas@arandanopartners.com.",
          "ONIX CYBERSECURITY PLATFORM es una marca titularidad de ARANDANO PARTNERS, S.L.",
        ],
      },
      {
        heading: "2. Objeto",
        paragraphs: [
          "El sitio ofrece información corporativa y comercial sobre productos, capacidades y servicios de inteligencia y ciberseguridad ONIX. El contenido tiene carácter general y no constituye una oferta contractual, asesoramiento profesional, garantía técnica, certificación ni compromiso de disponibilidad.",
        ],
      },
      {
        heading: "3. Uso permitido",
        paragraphs: [
          "El usuario se compromete a utilizar el sitio de forma lícita, diligente y conforme a la buena fe. Queda prohibido interferir con la disponibilidad o seguridad del sitio; intentar accesos no autorizados; introducir código malicioso; recopilar datos de forma automatizada sin permiso; suplantar identidades; vulnerar derechos de terceros; o utilizar los contenidos para actividades ilícitas.",
        ],
      },
      {
        heading: "4. Propiedad intelectual e industrial",
        paragraphs: [
          "Los nombres, signos, escudos, diseños, textos, interfaces, documentación y demás contenidos asociados a ONIX pertenecen a ARÁNDANO PARTNERS, S.L. o se utilizan con autorización de sus titulares. El acceso al sitio no concede licencia, cesión ni autorización de explotación salvo lo estrictamente necesario para navegar y consultar su contenido. No se permite copiar, modificar, distribuir, registrar, descompilar o explotar los contenidos sin autorización escrita, excepto cuando la ley lo permita expresamente.",
        ],
      },
      {
        heading: "5. Información técnica y enlaces",
        paragraphs: [
          "ARÁNDANO PARTNERS, S.L. procura que la información sea clara y actualizada, pero no garantiza que esté libre de errores o que todas las capacidades estén disponibles en todo momento, país, versión o despliegue. Los enlaces externos, cuando existan, se facilitan por conveniencia; su contenido y disponibilidad corresponden a sus respectivos responsables.",
        ],
      },
      {
        heading: "6. Responsabilidad",
        paragraphs: [
          "En la medida permitida por la ley, ARÁNDANO PARTNERS, S.L. no responde de decisiones adoptadas únicamente a partir de la información general del sitio, de interrupciones ajenas a su control, de usos ilícitos por terceros ni de daños derivados de sistemas, dispositivos o redes comprometidos del usuario. Nada de lo anterior limita responsabilidades que legalmente no puedan excluirse.",
        ],
      },
      {
        heading: "7. Legislación y jurisdicción",
        paragraphs: [
          "Este aviso se rige por la legislación española. Para cualquier controversia se aplicarán los juzgados y tribunales que resulten competentes conforme a la normativa vigente, sin perjuicio de los derechos imperativos de consumidores cuando fueran aplicables.",
        ],
      },
    ],
  },
  privacidad: {
    title: "Política de privacidad",
    description: "Política de privacidad de ONIX, marca de ARÁNDANO PARTNERS, S.L.",
    sections: [
      {
        heading: "1. Responsable",
        paragraphs: [
          "Responsable: ARÁNDANO PARTNERS, S.L.",
          "CIF: B75419093",
          "Domicilio: Calle Camp, 2, planta 1, 08021 Barcelona, España",
          "Contacto de privacidad: sistemas@arandanopartners.com",
        ],
      },
      {
        heading: "2. Datos tratados",
        paragraphs: [
          "Podemos tratar los datos que el usuario facilita mediante el formulario o por contacto directo: nombre, apellidos, empresa, cargo, correo profesional, teléfono opcional, área de interés, contenido del mensaje y datos técnicos necesarios para proteger el formulario y el sitio.",
          "No debe enviarse a través del formulario ninguna categoría especial de datos ni información clasificada, secreta o sensible.",
        ],
      },
      {
        heading: "3. Finalidades",
        list: [
          "responder solicitudes de información, demostración, partnership o integración;",
          "gestionar comunicaciones precontractuales o contractuales solicitadas;",
          "proteger el sitio, prevenir fraude, abuso y accesos no autorizados;",
          "cumplir obligaciones legales;",
          "enviar comunicaciones comerciales solo cuando exista consentimiento válido u otra base jurídica aplicable y se ofrezca oposición sencilla.",
        ],
      },
      {
        heading: "4. Base jurídica",
        paragraphs: [
          "La base puede ser el consentimiento del interesado, la aplicación de medidas precontractuales solicitadas, la ejecución de un contrato, el cumplimiento de obligaciones legales y el interés legítimo en proteger la infraestructura y prevenir abusos, según cada tratamiento.",
        ],
      },
      {
        heading: "5. Conservación",
        paragraphs: [
          "Los datos se conservan únicamente durante el tiempo necesario para atender la solicitud, gestionar la relación y cumplir los plazos legales aplicables. Solicitudes de contacto: hasta 24 meses desde la última interacción. Registros de seguridad y analítica: máximo 13 meses. Los registros de seguridad se minimizan y cuentan con retención limitada.",
        ],
      },
      {
        heading: "6. Destinatarios y encargados",
        paragraphs: [
          "Los datos podrán ser tratados por proveedores que presten servicios de hosting, correo, seguridad, soporte o formularios bajo contrato y garantías adecuadas. Relación de proveedores y, en su caso, transferencias internacionales: proveedores de alojamiento e infraestructura ubicados en la Unión Europea o con garantías adecuadas (cláusulas contractuales tipo); no se realizan transferencias fuera del EEE sin dichas garantías. No se venden datos personales.",
        ],
      },
      {
        heading: "7. Derechos",
        paragraphs: [
          "El interesado puede solicitar acceso, rectificación, supresión, oposición, limitación y portabilidad cuando proceda, así como retirar el consentimiento sin afectar al tratamiento previo. Puede dirigirse a sistemas@arandanopartners.com acreditando razonablemente su identidad. También puede reclamar ante la Agencia Española de Protección de Datos u otra autoridad competente.",
        ],
      },
      {
        heading: "8. Seguridad",
        paragraphs: [
          "Aplicamos medidas proporcionadas al riesgo para proteger los datos frente a pérdida, acceso, alteración o divulgación no autorizados. Ningún sistema conectado puede declararse absolutamente seguro; revisamos controles y respondemos a incidentes conforme al alcance aplicable.",
        ],
      },
      {
        heading: "9. Menores",
        paragraphs: [
          "El sitio y sus servicios B2B no se dirigen a menores. No se recaban conscientemente datos de menores mediante el formulario.",
        ],
      },
      {
        heading: "10. Actualizaciones",
        paragraphs: [
          "Esta política podrá actualizarse para reflejar cambios legales, técnicos u operativos. Fecha de última revisión: 1 de septiembre de 2026.",
        ],
      },
    ],
  },
  cookies: {
    title: "Política de cookies",
    description: "Política de cookies del sitio onix-cybersecurity.tech.",
    sections: [
      {
        heading: "1. Qué son las cookies",
        paragraphs: [
          "Las cookies y tecnologías similares permiten recordar información o ejecutar funciones en el dispositivo del usuario. Este sitio utiliza por defecto únicamente las necesarias para seguridad, sesión, preferencias y funcionamiento solicitado.",
        ],
      },
      {
        heading: "2. Categorías",
        list: [
          "Necesarias: activas siempre porque permiten funciones esenciales.",
          "Analíticas: desactivadas hasta consentimiento; medirán uso agregado solo si se incorporan.",
          "Personalización: desactivadas hasta consentimiento cuando no sean necesarias.",
          "Marketing: no implementadas salvo decisión expresa, proveedor identificado y consentimiento válido.",
        ],
      },
      {
        heading: "3. Panel de consentimiento",
        paragraphs: [
          "Puedes aceptar, rechazar o configurar las cookies con igual facilidad desde el banner de consentimiento. No se cargan scripts no esenciales antes del consentimiento. Puedes retirar o modificar tu elección en cualquier momento desde el enlace permanente «Configurar cookies» del pie de página.",
        ],
      },
      {
        heading: "4. Tabla de almacenamiento utilizado",
        paragraphs: [
          "Actualmente el sitio únicamente utiliza el siguiente almacenamiento técnico de primera parte:",
        ],
        table: {
          headers: ["Nombre", "Proveedor", "Finalidad", "Categoría", "Duración"],
          rows: [
            [
              "onix_cookie_prefs",
              "ONIX (propia · localStorage)",
              "Guardar tus preferencias de consentimiento de cookies",
              "Necesaria",
              "Hasta revocación por el usuario",
            ],
          ],
        },
        paragraphsAfter: [
          "Si en el futuro se incorporan herramientas de analítica o marketing, esta tabla se actualizará con las cookies reales detectadas en producción antes de su activación. Actualmente no se utilizan cookies de terceros.",
        ],
      },
    ],
  },
  "terminos-de-uso": {
    title: "Términos de uso",
    description: "Términos de uso del sitio informativo ONIX.",
    sections: [
      {
        heading: "1. Alcance",
        paragraphs: [
          "Estos términos regulan el acceso y uso del sitio informativo ONIX. La contratación de productos, licencias, pilotos, integraciones o servicios se regirá por la propuesta, orden de trabajo y contrato que firmen las partes.",
        ],
      },
      {
        heading: "2. Ausencia de autorización operativa",
        paragraphs: [
          "La información del sitio no autoriza al usuario a realizar vigilancia, monitorización, pruebas, análisis, recopilación, respuesta o acceso sobre sistemas, personas, datos o infraestructuras. Toda actividad operativa requiere base jurídica, autorización del titular, alcance, controles y contrato aplicable.",
        ],
      },
      {
        heading: "3. Descripciones de producto",
        paragraphs: [
          "Las funciones descritas pueden depender de versión, configuración, infraestructura, licencias, fuentes, jurisdicción y pruebas de aceptación. «En desarrollo», «capacidad técnica» y «capacidad de implantación» no equivalen a disponibilidad general. ARÁNDANO PARTNERS, S.L. podrá modificar la información sin alterar contratos ya firmados.",
        ],
      },
      {
        heading: "4. Uso de materiales",
        paragraphs: [
          "Se permite consultar e imprimir extractos para evaluación interna y no comercial, manteniendo avisos de titularidad. Cualquier reproducción, distribución, adaptación, benchmarking publicado, extracción automatizada o uso de marca requiere autorización escrita cuando la ley no establezca una excepción.",
        ],
      },
      {
        heading: "5. Seguridad y notificación",
        paragraphs: [
          "No se permite realizar pruebas de seguridad contra el sitio sin autorización escrita. Las vulnerabilidades potenciales deben comunicarse de buena fe a sistemas@arandanopartners.com, sin acceder a datos ajenos, alterar sistemas, mantener persistencia, extorsionar ni publicar antes de recibir una respuesta razonable.",
        ],
      },
      {
        heading: "6. Suspensión",
        paragraphs: [
          "El acceso podrá restringirse ante abuso, riesgo de seguridad, incumplimiento o exigencia legal, sin perjuicio de otros derechos.",
        ],
      },
      {
        heading: "7. Cambios",
        paragraphs: [
          "Fecha de entrada en vigor: 1 de septiembre de 2026. Los cambios materiales se notificarán de forma proporcionada. El uso continuado no sustituye el consentimiento cuando la ley lo exija.",
        ],
      },
    ],
  },
};
